import type { FC } from 'react';
import React from 'react';
import List from '@mui/material/List';
import { usePlatformsTranslations } from './hooks/use-platforms-translations';
import { PlatformsListItem } from './PlatformsListItem';

type PlatformsListProps = {
  platform: string;
};

export const PlatformsList: FC<PlatformsListProps> = ({ platform }) => {
  const platforms = usePlatformsTranslations();
  return (
    <List className="page-403__list">
      {platforms[platform] &&
        platforms[platform].map((item, index) => (
          <PlatformsListItem
            key={item.linkUrl + item.text}
            icon={index + 1}
            text={item.text}
            linkUrl={item.linkUrl || '#'}
            translateKey={item.key}
          />
        ))}
    </List>
  );
};
